declare const RELEASE_VERSION: string | undefined;

export const releaseVersion = () => {
  if (typeof RELEASE_VERSION === 'undefined') {
    return undefined;
  }

  return RELEASE_VERSION;
};
